import Resource from './Resource';

export default class Role extends Resource{
	constructor(){
		let config = { 
			route: "roles",
		};
		super(config);
		return this;
	}

	get(){
		return this.request();
	}
}
